import React from "react";

const ArrowUpIcon = (props) => {
	return (
		<svg
			width="83"
			height="83"
			viewBox="0 0 83 83"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<g filter="url(#filter0_bd_1854_438210)">
				<rect
					x="79"
					width="75"
					height="75"
					rx="37.5"
					transform="rotate(90 79 0)"
					fill="url(#paint0_linear_1854_438210)"
					shapeRendering="crispEdges"
				/>
				<rect
					x="78.25"
					y="0.75"
					width="73.5"
					height="73.5"
					rx="36.75"
					transform="rotate(90 78.25 0.75)"
					stroke="#4E4B66"
					strokeWidth="1.5"
					shapeRendering="crispEdges"
				/>
				<path
					d="M54 35L43.4206 22.3047C42.4211 21.1053 40.5789 21.1053 39.5794 22.3047L29 35"
					stroke="#A0A3BD"
					strokeWidth="3"
					strokeLinecap="round"
				/>
				<path
					d="M54 47.5L29 47.5"
					stroke="#A0A3BD"
					strokeWidth="3"
					strokeLinecap="round"
				/>
			</g>
			<defs>
				<filter
					id="filter0_bd_1854_438210"
					x="-26"
					y="-30"
					width="135"
					height="135"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood
						floodOpacity="0"
						result="BackgroundImageFix"
					/>
					<feGaussianBlur
						in="BackgroundImageFix"
						stdDeviation="15"
					/>
					<feComposite
						in2="SourceAlpha"
						operator="in"
						result="effect1_backgroundBlur_1854_438210"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite
						in2="hardAlpha"
						operator="out"
					/>
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_backgroundBlur_1854_438210"
						result="effect2_dropShadow_1854_438210"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_1854_438210"
						result="shape"
					/>
				</filter>
				<linearGradient
					id="paint0_linear_1854_438210"
					x1="116.5"
					y1="0"
					x2="116.5"
					y2="75"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#191726" />
					<stop
						offset="1"
						stopColor="#050512"
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default ArrowUpIcon;
